const REPORT_TYPE_LABELS = {
  yjdbg: '一季度报',
  bndbg: '半年报',
  sjdbg: '三季度报',
  ndbg: '年报'
};

/** 根据 report_period + report_type 生成展示名，修正历史任务名中年份错误 */
export function formatCrawlerTaskLabel(task) {
  if (!task) return '';
  const match = String(task.report_period || '').match(/^(\d{4})Q[1-4]$/);
  if (match && task.report_type && REPORT_TYPE_LABELS[task.report_type]) {
    return `${match[1]}年${REPORT_TYPE_LABELS[task.report_type]}爬取`;
  }
  return task.task_name || '';
}
